import { getListstStore } from "@/store/lists/actions";
import { ContactListTypeEnum } from "@dev/ee-api/ee-api-models";
import { useSelector } from "react-redux";

enum CategoryOptions {
    Lists = 'Lists'
}

export const useContactLists = () => {
    const { listNamesCollection } = useSelector(getListstStore);

    const lists = listNamesCollection?.filter(list => list.Type !== ContactListTypeEnum.PaidSubscription);
    return lists?.map(list => ({
        label: list.ListName,
        category: CategoryOptions.Lists,
        id: list.PublicListID
    }));
}